/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Members_TotalInputs */

const en_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members Total`)
};

const de_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder gesamt`)
};

const es_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros en total`)
};

const fr_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre total de membre(s)`)
};

const it_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membri totali`)
};

const pt_br2_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membros no total`)
};

const pl_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba członków`)
};

const hu_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tag (összesen)`)
};

const ro_admin_dashboard_members_total = /** @type {(inputs: Admin_Dashboard_Members_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Membri`)
};

/**
* | output |
* | --- |
* | "Members Total" |
*
* @param {Admin_Dashboard_Members_TotalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_members_total = /** @type {((inputs?: Admin_Dashboard_Members_TotalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Members_TotalInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_members_total(inputs)
	if (locale === "de") return de_admin_dashboard_members_total(inputs)
	if (locale === "es") return es_admin_dashboard_members_total(inputs)
	if (locale === "fr") return fr_admin_dashboard_members_total(inputs)
	if (locale === "it") return it_admin_dashboard_members_total(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_members_total(inputs)
	if (locale === "pl") return pl_admin_dashboard_members_total(inputs)
	if (locale === "hu") return hu_admin_dashboard_members_total(inputs)
	return ro_admin_dashboard_members_total(inputs)
});
export { admin_dashboard_members_total as "admin.dashboard.members_total" }